/**
 * Moves focus to `el` and brings it into view clear of whatever is pinned over the top of its
 * scroll area: a report's or the Insights page's edit bar and filter header.
 *
 * focus() on its own scrolls only an element outside the viewport, so a heading that sits behind a
 * pinned header stays behind it, focused and hidden (WCAG 2.4.11). The page's scroll margins add the
 * pinned bars' measured heights (the page root's `[&_*]:scroll-mt-[…]`), and an element whose top is
 * inside that margin is under them: it is aligned to its margin (`start`), just below the bars.
 * Chrome's `nearest` counts such an element as in view whatever its margin says, so it is kept for
 * the rest: an element below the fold comes up to the bottom edge, and one already clear of the bars
 * does not move. On a page with nothing pinned it scrolls as focus() would have.
 *
 * Also $focusInView(el) in markup (app.js), for a handler written inline.
 */
export function focusInView(el) {
    if (! el || typeof el.focus !== 'function') return;

    el.focus({ preventScroll: true });

    if (typeof el.scrollIntoView !== 'function' || typeof el.getBoundingClientRect !== 'function' || typeof window.getComputedStyle !== 'function') return;

    const margin = parseFloat(window.getComputedStyle(el).scrollMarginTop) || 0;
    const isUnderPinned = el.getBoundingClientRect().top - margin < scrollportTop(el);

    el.scrollIntoView({ block: isUnderPinned ? 'start' : 'nearest', inline: 'nearest' });
}

/** The top of the nearest ancestor that scrolls, where anything pinned in it starts. */
function scrollportTop(el) {
    for (let node = el.parentElement; node; node = node.parentElement) {
        if (/(auto|scroll)/.test(window.getComputedStyle(node).overflowY)) return node.getBoundingClientRect().top;
    }

    return 0;
}
